const messages = {
    buttons: {
        productBrochures: "Utforsk",
    },
    index: {
        title: "PRODUKTINFORMASJON",
        description: "Last ned de nyeste brosjyrene og flygebladene om våre Bridgestone- og Firestone-dekk her.",
        categories: {
            productBrochures: {
                title: "Produktbrosjyrer",
                description: "Brosjyrer for Bridgestone- og Firestone-dekksortiment",
            },
            bDrive: {
              title: "Produktbilder",
              description: "Du finner noverande bilder for nedlasting i vårt B-DRIVE-portal.",
            },
        
          kickback: {
            description: "Deltakende virksomheter krediteres kickback-gebyr på grunnlag av innsendte salgstall.",
          },}
    }
};

export default {
    messages,
};
